.section {
  margin-top: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-3);
  border-top: 1px solid var(--tuna-border-default);
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.heading {
  font-size: var(--tuna-typography-caption-fontSize);
  margin: 0;
  color: var(--tuna-content-secondary);
  font-weight: 600;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.link {
  /* Sized by ui-lib Button size="small"; class reserved for future tweaks. */
}
